module.exports = __webpack_public_path__ + "static/media/fundoo.241f3228.jpg";